<template>

      <input
        v-model="phones"
        ref="phone"
        name="multiple_phones"
        :placeholder="'Input phone number'|translate"

      />

</template>

<script>
import Utils from '@/helpers/utils'
import Tagify from '@yaireo/tagify'
/* eslint-disable */
export default {
  name: "SelectLocation",
  props: ["item","api_url"],
  data() {
    return {
      tagify: null,
      ignore_check_phone: false,
      phones: this.item.phone ? this.item.phone.split(",") : [],
    };
  },

  methods: {
    removePhone (phone) {
      let values = this.tagify.value.map(item => {
        return item.value
      })
      let index = values.indexOf(phone)
      console.log('values', values)
      console.log('index', index)
      if (index !== -1) {
        this.ignore_check_phone = true
        values.splice(index, 1)
        this.tagify.removeAllTags()

        this.tagify.addTags(values)
        this.ignore_check_phone = false
      }
    },
    generalCheckPhone (phone) {
      if (phone) {
        let link = `${this.api_url}${phone}`
        if (this.item.id) {
          link += '?from_id=' + this.item.id
        }
        Utils.requestV2(this, true).get(
          link
        ).then((response) => {
          console.log('response', response)
          if (response.data === -1) {
            Utils.showError(this, `Số điện thoại: ${phone} không đúng định dạng là số điện thoại di động`)
            console.log('this.tagify', this.tagify)
            this.removePhone(phone)
          } else if (response.data === true) {
            Utils.showError(this, `Số điện thoại: ${phone} đã có, vui lòng nhập số khác`)
            this.removePhone(phone)
          } else {
            Utils.showSuccess(this, `Số điện thoại: ${phone} khả dụng để thêm vào`)
          }
        })
      }
    },
    getPhones(){
      return this.tagify.value.map(item => {
        return item.value
      })

    },

    updateLocation() {
      this.$emit("updateLocation", {
        province_id: this.province_id,
        district_id: this.district_id,
      });
    }
  },
  mounted() {
      setTimeout(() => {
        this.ignore_check_phone = true;
        let input = document.querySelector('input[name=multiple_phones]')
        
        this.tagify = new Tagify(input, {
          enforceWhitelist: false
        }).on('add', e => {
          if (!this.ignore_check_phone) {
            this.generalCheckPhone(e.detail.data.value)
          }
        })

        setTimeout(()=>{
          this.ignore_check_phone = false; 
        },200)

      }, 100)
  },
  beforeDestroy() {
    this.tagify.destroy();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/elements/MultilePhone.vue